import GLightbox from 'glightbox';

export const init = () => {
	const jsOpenVideo = Array.from(document.querySelectorAll('.js-open-video'));
	const lightbox = GLightbox({
		touchNavigation: false,
		draggable: false,
		autoplayVideos: false,
		zoomable: false,
		plyr: {
			js: 'https://cdn.plyr.io/3.6.3/plyr.polyfilled.js',
			config: {
				youtube: {
					noCookie: true,
				},
			},
		},
	});

	if (jsOpenVideo.length > 0) {
		jsOpenVideo.forEach((el) => {
			el.addEventListener('click', () => {
				lightbox;
			});
		});
	}
};
